import React, {useEffect, useState} from 'react';
import {getHeaderNotification,  getFaqsData} from './../utils/endpoints'
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';


const Home = () => {
  const [headerNotificationData, setheaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 600,
    autoplaySpeed: 6000,
    centerMode: true,
    cssEase: "linear",
    nextArrow: <NextArrow/>,
    prevArrow: <PrevArrow/>,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1.25,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false
            }
        },
        {
            breakpoint: 200,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false
            }
        }
    ]
  };

  function NextArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      ><FontAwesomeIcon icon={faAngleRight} /></div>
    );
  }
  
  function PrevArrow(props) {
    const { className, onClick } = props;
    return (
      <div
        className={className}
        onClick={onClick}
      ><FontAwesomeIcon icon={faAngleLeft} /></div>
    );
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqs = await getFaqsData();
        const headerNotificationData = await getHeaderNotification();
        setheaderNotificationData(headerNotificationData);
        setFaqs(faqs);
        
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <div><Loading /></div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <Helmet>
      <title>Things to do in nathdwara | biggest shiva statue in rajasthan</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <section className='section-breadcrumb'>
      <Container>
      <ul>
            <li><a href="/">Home</a></li>
            <li>About Us</li>
        </ul>
        <h1>About Us</h1>
      </Container>
    </section>
    <section className='section-about'>
    <Container>
      <Row>
        <Col lg={7}>
          <h2>Welcome to Statue of Belief</h2>
          <p>Come and experience the spiritual bliss of Nathdwara by witnessing the divine power of belief and capturing the incredible views of Rajasthan. The <b>'Statue of Belief'</b> is an awe-inspiring <b>369 feet tall art of Lord Shiva</b> located in <b>Nathdwara, Rajasthan</b>. It is one of the <b>largest Shiva statues in the world</b> and among the five largest statues worldwide. This holy town near Udaipur is now another great reason for pilgrims to visit!</p>
          <p>The project was envisioned by <b>Mr. Madan Paliwal, Chairman of Miraj Group</b>, Udaipur, and created by the renowned studio Maturam Art, with Skeleton Consultants rendering the structural design. <b>Shapoorji Pallonji E&C</b> had the contract for constructing the Statue and other amenities. <b>Standing at a towering 369ft</b>, the <b>Vishwas Swaroopam</b> is an awe-inspiring Shiva statue that can be spotted from up to 20km away! It took <b>750 skilled workers 10 years</b> to complete this impressive structure, with the <b>foundation stone laid in 2012</b>. The statue, which includes a 34m high pedestal, reaches a height of 112m.</p>
          <p>The surface has been coated with zinc to increase its longevity of <b>250 years</b> and finished with copper, sculpted into Shiva's exact details, expressions, features, and emotions. <b>The Statue is built to withstand wind speeds up to 250 kmph and earthquakes of Zone IV intensity, despite Nathdwara being in Zone II.</b></p>
          <div className="statue-stats">
                <ul>
                    <li>369 <span><b>ft.</b> height</span></li>
                    <li>32 <span>acre total area</span></li>
                    <li>2.5 <span>lakh cubic ton concrete</span></li>
                </ul>
            </div>
        </Col>
        <Col lg={5}>
          <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/about-thumb-01-1-1.webp" loading="lazy" alt="Statue of Belief" className='img-fluid'/>
        </Col>
      </Row>
    </Container>
    </section>
    <section className='sectionAbout-sub bg-gray'>
      <Container>
        <Row>
          <Col lg={4} className='mb-lg-0 mb-4'>
          <Slider {...settings}>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/env-01.webp" loading="lazy" alt="" />
            </div>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/env-02.webp" loading="lazy" alt="" />
            </div>
          </Slider>
          </Col>
          <Col lg={8}>
            <div className='description'>
              <div>
              <h3>Envisioning of Statue of Belief</h3>
            <p>The ‘<b>Statue of Belief</b>’, was envisioned by <b>Mr. Madan Paliwal, Chairman of Miraj Group, Udaipur</b>. He conceptualised a giant statue of Lord Shiva built on Ganesh Tekri, a hillock in Nathdwara. His vision also included putting <b>Nathdwara on the tourist map of the world</b>. The concept was further developed by renowned studio Maturam Art that designed the 369 feet high statue, while the structural design was rendered by Skeleton Consultants. The construction contract for the statue and other amenities in the complex was awarded to <b>Shapoorji Pallonji E&C</b>, and the work started in early 2016.</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    <section className='sectionAbout-sub'>
      <Container>
        <Row>
        <Col lg={8} className='order-lg-0 order-2'>
            <div className='description'>
              <div>
              <h3>Design Structure</h3>
              <p>The <b>Statue is designed as a three-layered structure</b>. The innermost layer comprises four RCC core walls that rise from the base of the hillock and form the structural core of the statue. The second layer is a structural steel framework. </p><p>The third layer is a concrete shell built using ultra-high-performance concrete and moulded to the statue’s profile. All three layers are structurally connected. The statue is sculpted into a masterpiece that has all the details, expressions, features, and emotions of Shiva cast in shell concrete. The surface of the statue has been coated with zinc and finished with copper to increase its longevity, with a lifespan of 250 years. It can withstand wind speeds up to 250 kmph and earthquakes of Zone IV intensity, even though Nathdwara is in Zone II.</p>
              </div>
            </div>
          </Col>
          <Col lg={4} className='order-lg-1 order-1 mb-lg-0 mb-3'>
          <Slider {...settings}>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/under-construction-01.webp" alt="" loading="lazy"/>
            </div>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/under-construction-02.webp" alt="" loading="lazy"/>
            </div>
          </Slider>
          </Col>
        </Row>
      </Container>
    </section>
    <section className='sectionAbout-sub bg-gray'>
      <Container>
        <Row>
          <Col lg={4} className='mb-lg-0 mb-3'>
          <Slider {...settings}>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/facilities-11.webp" loading="lazy" alt="" />
            </div>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/facilities-12-1.webp" loading="lazy" alt="" />
            </div>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/facilities-13.webp" loading="lazy" alt="" />
            </div>
            <div>
              <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/facilities-14.webp" loading="lazy" alt="" />
            </div>
          </Slider>
          </Col>
          <Col lg={8}>
            <div className='description'>
            <div>
            <h3>Highlights</h3>
            <p>Facilities within the project include Visitors’ Room, Administration Office, and a VIP Lounge. The hollow space within the shell skin has slabs at various levels to enable horizontal and vertical access inside the statue. Two viewing galleries have been provided at 270 ft and 280 ft levels.</p>
            <p>Based on a Computational Fluid Dynamics (CFD) study of the statue, the required number of ventilators and shafts have been provided for natural ventilation, and LED lighting inside the Statue and in the allied buildings, to reduce power consumption.</p>
            <p>A water jet at the apex of the statue represents the Holy River Ganga, flowing from Shiva’s Jata (matted hair). A 25-ft high Nandi Statue (the celestial bull and vehicle of Lord Shiva) has been built facing Shiva, beholding his divine form with reverence and love.</p>
            <p>The area surrounding the Statue includes facilities for parking, pavements, a water body, bridge, landscaping, an amphitheatre, food court, handicraft shops, and an amusement park for children.</p>
            </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    <section className='bottom-writup'>
      <Container>
        <div className='bottom-writup-thumb'>
          <img src="https://www.theindianthing.com/shiva-statue/wp-content/uploads/2023/06/about-banner-01.webp" loading="lazy" alt="" />
        </div>
        <div className='bottom-writup-description'>
        <p>The hillock is built with 300-mm thick RCC peripheral walls, while the skin of the statue is built using 200-mm thick RCC walls. The exterior surface of the hillock was finished to resemble a snow-clad mountain.</p>

        <p>Single-use FRP moulds were specially designed and made by the sculptor to obtain the required exterior profile and features of the statue. The inner profile was obtained by using custom-made plywood moulds to suit the profile. The construction involved 2,650 MT structural steel fabrication and erection; 2,700 MT of reinforcement steel; and 8,500 Cum of ultra-high-performance self-compacting concrete.</p>

        <p>Initially, two tower cranes were provided. Once the hillock was built, only one tower crane was retained for the statue portion. The peak labour strength was 1,000.</p>

        <p>The most difficult portion to construct was the folded left leg which is 60-ft cantilever from the thigh portion to the knee and resting on the other thigh which is of 60 ft unsupported length. The entire portion was temporarily supported over a sturdy scaffold frame till the concrete attained its strength. The concreting of the right arm resting on the left leg was equally challenging. It was cast from the left leg portion moving in upwards and then joining the shoulder. The structural framing comprising various elements was carefully assembled by means of the tower crane prior to the final welding.</p>

        <p>After completion of the structural works, the metallizing work was taken up. The surface of the statue was cleaned, sandblasted and then sprayed with liquified 99.9% pure zinc with the help of a metallizing machine to form a protective coating. The entire surface was then finished with a coating of copper. (to give the natural aura, to give the natural effect, to make it look attractive from a distance)</p>

        <p>This is the glory of the statue and there are more chapters to unfold while you’re at the place.</p>
        </div>
      </Container>
    </section>
    <Faqs compData={faQSlice.slice(0,5)} />
    <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
    <Footer />
    </div>
  );
};

export default Home;